import axios from '@/plugins/axios';

export const getToken = async (nonce: string): Promise<any> => new Promise((resolve, reject) => {
  axios.post('api/auth/ozon', { nonce }).then((result) => {
    resolve(result.data);
  }).catch((e) => {
    reject(e.response.data);
  });
});
